import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "p-6 space-y-5"
};
const _hoisted_2 = {
  class: "bg-slate-50 rounded-xl p-4 space-y-3"
};
const _hoisted_3 = {
  class: "flex items-center justify-between gap-4"
};
const _hoisted_4 = {
  class: "text-sm font-medium text-slate-900 truncate"
};
const _hoisted_5 = {
  class: "flex items-center justify-between gap-4"
};
const _hoisted_6 = {
  class: "text-sm font-mono text-slate-900 truncate"
};
const _hoisted_7 = {
  class: "flex items-center justify-between gap-4"
};
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-rose-700 bg-rose-50 rounded-lg px-3 py-2"
};
const _hoisted_9 = {
  class: "space-y-2"
};
const _hoisted_10 = {
  class: "flex items-center gap-3"
};
const _hoisted_11 = ["disabled"];
const _hoisted_12 = {
  class: "min-w-0 flex-1 text-sm text-slate-600 truncate"
};
const _hoisted_13 = {
  key: 0,
  class: "text-xs text-green-700"
};
const _hoisted_14 = {
  class: "flex items-center justify-between gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-2xl"
};
const _hoisted_15 = ["disabled"];
import { computed, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import AppModal from '@/components/AppModal.vue';
import { createDefaultReferrerFranchiseeBind, uploadCommissionLakalaFile } from '@/api/commission';
const AGREEMENT_MAX_FILE_SIZE = 5 * 1024 * 1024;
export default {
  __name: 'ReferrerLakalaBindModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    referrerId: {
      type: [Number, String],
      default: null
    },
    referrerInfo: {
      type: Object,
      default: null
    },
    receiver: {
      type: Object,
      default: null
    },
    bindRelation: {
      type: Object,
      default: null
    }
  },
  emits: ['update:visible', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const fileInputRef = ref(null);
    const selectedFileName = ref('');
    const uploadedFile = ref(null);
    const uploading = ref(false);
    const submitting = ref(false);
    const AGREEMENT_ALLOWED_EXTENSIONS = ['jpg', 'png', 'pdf'];
    const AGREEMENT_ALLOWED_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];
    const referrerName = computed(() => props.referrerInfo?.referrerName || props.referrerInfo?.name || '-');
    const receiverNo = computed(() => props.receiver?.receiverNo || '');
    const bindStatusText = computed(() => {
      const status = props.bindRelation?.bindStatus;
      if (status === 0) return '审核中';
      if (status === 1) return '已绑定';
      if (status === 2) return '绑定拒绝';
      if (status === 3) return '解绑审核中';
      if (status === 4) return '已解绑';
      if (status === 5) return '解绑拒绝';
      return '未绑定';
    });
    const bindStatusClass = computed(() => {
      const status = props.bindRelation?.bindStatus;
      if (status === 1) return 'status-badge is-success';
      if (status === 2 || status === 5) return 'status-badge is-rose';
      if (status === 0 || status === 3) return 'status-badge is-warning';
      return 'status-badge is-neutral';
    });
    const clearFileInput = () => {
      if (fileInputRef.value) {
        fileInputRef.value.value = '';
      }
    };
    const validateAgreementFile = file => {
      const extension = file.name?.split('.').pop()?.toLowerCase() || '';
      const extensionAllowed = AGREEMENT_ALLOWED_EXTENSIONS.includes(extension);
      const typeAllowed = !file.type || AGREEMENT_ALLOWED_TYPES.includes(file.type);
      if (!extensionAllowed || !typeAllowed) {
        ElMessage.error('合作协议仅支持 JPG、PNG、PDF 格式');
        return false;
      }
      if (file.size > AGREEMENT_MAX_FILE_SIZE) {
        ElMessage.error('合作协议文件大小不能超过 5M');
        return false;
      }
      return true;
    };
    const resetState = () => {
      selectedFileName.value = '';
      uploadedFile.value = null;
      uploading.value = false;
      submitting.value = false;
      clearFileInput();
    };
    const handleClose = () => {
      resetState();
      emit('update:visible', false);
    };
    const handleFileChange = async event => {
      const file = event.target.files?.[0];
      if (!file) return;
      selectedFileName.value = '';
      uploadedFile.value = null;
      if (!validateAgreementFile(file)) {
        clearFileInput();
        return;
      }
      if (!props.referrerId) {
        ElMessage.error('缺少引入人信息，无法上传合作协议');
        clearFileInput();
        return;
      }
      selectedFileName.value = file.name;
      uploading.value = true;
      try {
        const formData = new FormData();
        formData.append('referrerId', props.referrerId);
        formData.append('attType', 'SPLIT_COOPERATION_FILE');
        formData.append('remark', '引入人与加盟商分账合作协议');
        formData.append('module', 'commission/referrer-bind');
        formData.append('file', file);
        uploadedFile.value = await uploadCommissionLakalaFile(formData);
        ElMessage.success('合作协议上传成功');
      } catch (error) {
        console.error('上传合作协议失败:', error);
        ElMessage.error(error.message || '上传合作协议失败');
      } finally {
        uploading.value = false;
      }
    };
    const handleSubmit = async () => {
      if (!uploadedFile.value?.lakalaFileName || !uploadedFile.value?.lakalaFilePath) {
        ElMessage.warning('请先上传合作协议');
        return;
      }
      submitting.value = true;
      try {
        await createDefaultReferrerFranchiseeBind(props.referrerId, {
          entrustFileName: uploadedFile.value.lakalaFileName,
          entrustFilePath: uploadedFile.value.lakalaFilePath
        });
        ElMessage.success('绑定申请已提交');
        emit('success');
        handleClose();
      } catch (error) {
        console.error('提交绑定申请失败:', error);
        ElMessage.error(error.message || '提交绑定申请失败');
      } finally {
        submitting.value = false;
      }
    };
    watch(() => props.visible, value => {
      if (value) {
        resetState();
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.visible,
        size: "lg",
        "z-index": 60,
        scrollable: false,
        onClose: handleClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
        }, [_cache[2] || (_cache[2] = _createElementVNode("div", null, [_createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-900"
        }, "发起分账绑定"), _createElementVNode("p", {
          class: "text-sm text-slate-500 mt-0.5"
        }, "上传合作协议后提交拉卡拉审核")], -1)), _createElementVNode("button", {
          onClick: handleClose,
          class: "p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
        }, [...(_cache[1] || (_cache[1] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[3] || (_cache[3] = _createElementVNode("span", {
          class: "text-sm text-slate-500"
        }, "引入人", -1)), _createElementVNode("span", _hoisted_4, _toDisplayString(referrerName.value), 1)]), _createElementVNode("div", _hoisted_5, [_cache[4] || (_cache[4] = _createElementVNode("span", {
          class: "text-sm text-slate-500"
        }, "接收方编号", -1)), _createElementVNode("span", _hoisted_6, _toDisplayString(receiverNo.value || '-'), 1)]), _createElementVNode("div", _hoisted_7, [_cache[5] || (_cache[5] = _createElementVNode("span", {
          class: "text-sm text-slate-500"
        }, "绑定状态", -1)), _createElementVNode("span", {
          class: _normalizeClass(["status-badge", bindStatusClass.value])
        }, _toDisplayString(bindStatusText.value), 3)]), __props.bindRelation?.remark ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(__props.bindRelation.remark), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_cache[6] || (_cache[6] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700"
        }, [_createElementVNode("span", {
          class: "text-red-500"
        }, "*"), _createTextVNode(" 合作协议 ")], -1)), _createElementVNode("input", {
          ref_key: "fileInputRef",
          ref: fileInputRef,
          type: "file",
          accept: ".jpg,.png,.pdf",
          class: "hidden",
          onChange: handleFileChange
        }, null, 544), _createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          disabled: uploading.value || submitting.value,
          onClick: _cache[0] || (_cache[0] = $event => fileInputRef.value?.click())
        }, _toDisplayString(uploading.value ? '上传中...' : '选择文件'), 9, _hoisted_11), _createElementVNode("div", _hoisted_12, _toDisplayString(selectedFileName.value || uploadedFile.value?.lakalaFileName || '未选择文件'), 1)]), uploadedFile.value?.lakalaFilePath ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 文件已上传，可以提交绑定申请 ")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("button", {
          onClick: handleClose,
          class: "btn-secondary"
        }, "稍后绑定"), _createElementVNode("button", {
          onClick: handleSubmit,
          disabled: uploading.value || submitting.value,
          class: "btn-primary"
        }, _toDisplayString(submitting.value ? '提交中...' : '提交绑定申请'), 9, _hoisted_15)])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};